<div *ngIf="!isAPIReference">
  <div *ngFor="let image of expandImages; let i = index">
    <div class="accordion card">
      <div class="card-header" (click)="toggleCollapsed(i)">
        <a [ngClass]="getActiveStyle(i)">{{ image.title }}</a>
      </div>
      <div [ngClass]="getAccordionStyle(i)" class="card-body">
        <img src="{{ image.image }}" alt="" width="100%" />
      </div>
    </div>
    <div [innerHTML]="image.description | mdToHtml"></div>
  </div>
</div>

<div *ngIf="isAPIReference">
  <div *ngFor="let image of accordianImage; let i = index">
    <div class="accordion-apiDoc">
      <div class="card-header">
        <h4 (click)="toggleCollapsed(i)" class="flex-text">
          <div [ngClass]="getArrowIcons(i)" class="arrow-icon">
            {{ image.title }}
          </div>
        </h4>
      </div>
      <div [ngClass]="getAccordionStyle(i)" class="collapsible card-body" [innerHTML]="image.body || '' | mdToHtml"></div>
    </div>
  </div>
</div>
